import { render } from "./DatesBlock.vue?vue&type=template&id=732282c3"
import script from "./DatesBlock.vue?vue&type=script&lang=js"
export * from "./DatesBlock.vue?vue&type=script&lang=js"

import "./DatesBlock.vue?vue&type=style&index=0&id=732282c3&lang=scss"
script.render = render

export default script